import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { RoutePaths } from '../models/route-paths.model';
import { UserScopesService } from '../services/user-scopes.service';

export const hasRequiredScopesGuard: (requiredScopes: string[]) => CanActivateFn = (requiredScopes) => () => {
  const router = inject(Router);
  return inject(UserScopesService)
    .getScopes()
    .pipe(
      map((actualScopes) => {
        const hasRequiredScopes = requiredScopes?.every((value) => actualScopes.values.includes(value));
        return hasRequiredScopes ? true : router.parseUrl(RoutePaths.Forbidden);
      }),
      catchError(() => of(router.parseUrl(RoutePaths.Forbidden)))
    );
};
